import React from "react";
import { useTranslate } from "@refinedev/core";
import { EyeIcon } from "@phosphor-icons/react";
import { Button, ButtonSize } from "@libertify/ui";
import { theme } from "antd";

interface PreviewButtonProps {
  onClick: () => void;
  size?: ButtonSize;
}

/** "Preview" action shared by `DocumentFileRow` (create) and `DocumentEditRow`
 *  (edit), so its styling lives in one place instead of two. */
export const PreviewButton: React.FC<PreviewButtonProps> = ({
  onClick,
  size = "m",
}) => {
  const t = useTranslate();
  const { token } = theme.useToken();
  return (
    <Button
      variant="outlined"
      size={size}
      leftIcon={<EyeIcon size={15} />}
      onClick={onClick}
      style={{
        borderColor: token.colorBorder,
        color: token.colorTextBase,
        fontWeight: 500,
      }}
    >
      {t("createExperience.addOns.documents.preview")}
    </Button>
  );
};
